import { computed, ref, watch } from 'vue';

/**
 * 左サイドメニューの展開状態を管理するComposable
 */
export const useExpandableLeftMenu = (
  getExpandedState: () => boolean,
  setExpandedState: (expanded: boolean) => void,
) => {
  const isExpanded = ref(getExpandedState());
  const isMenuVisible = computed(() => isExpanded.value || isHovering.value);
  const isHovering = ref(false);
  const isMenuTransitioning = ref(false);

  const toggleIsFolded = (shouldPersistState = true) => {
    if (isExpanded.value) {
      isHovering.value = false;
    }

    if (shouldPersistState) {
      setExpandedState(!isExpanded.value);
    }
    isExpanded.value = !isExpanded.value;
  };

  const handleMouseEnter = () => {
    if (!isMenuTransitioning.value) {
      isHovering.value = true;
    }
  };

  const handleMouseLeave = () => {
    if (!isMenuTransitioning.value) {
      isHovering.value = false;
    }
  };

  watch(
    () => isExpanded.value,
    () => {
      isMenuTransitioning.value = true;
      setTimeout(() => (isMenuTransitioning.value = false), 320);
    },
  );

  return {
    isExpanded,
    isMenuVisible,
    toggleIsFolded,
    handleMouseEnter,
    handleMouseLeave,
  };
};
